import { render, staticRenderFns } from "./property-types.vue?vue&type=template&id=d91ab27a&"
import script from "./property-types.vue?vue&type=script&lang=js&"
export * from "./property-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports